import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./LangContext";
import Home from "./pages/Home";
import DonationSuccess from "./pages/DonationSuccess";
import DonationCancel from "./pages/DonationCancel";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import NewsArticle from "./pages/NewsArticle";
import NewsList from "./pages/NewsList";
import WhySportPage from "./pages/WhySportPage";

function App() {
    return (
        <div className="App bg-ink min-h-screen">
            <LangProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/news" element={<NewsList />} />
                        <Route path="/news/:slug" element={<NewsArticle />} />
                        <Route path="/why-sport" element={<WhySportPage />} />
                        <Route path="/donate/success" element={<DonationSuccess />} />
                        <Route path="/donate/cancel" element={<DonationCancel />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    theme="dark"
                    position="bottom-left"
                    toastOptions={{
                        style: {
                            background: "#121214",
                            border: "1px solid rgba(255,255,255,0.1)",
                            color: "#fafafa",
                        },
                    }}
                />
            </LangProvider>
        </div>
    );
}

export default App;
